<template>
  <el-container class="layout-container">
    <el-header>
      <!-- 头部导航栏 -->
      <div class="header">
        <div class="logo-title">
          <img src="@/assets/logo1.png" alt="logo" class="header-logo" />
          <h2>焦化11种隐患人管理后台</h2>
        </div>
        <div class="user-info">
          <span class="welcome-text">欢迎您，{{ name || '管理员' }}</span>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goToChangePassword">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    
    <el-container>
      <el-aside width="220px">
        <!-- 侧边栏菜单 -->
        <sidebar />
      </el-aside>
      
      <el-main>
        <!-- 主内容区域 -->
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from './components/Sidebar'
import AppMain from './components/AppMain.vue'
import { getToken } from '@/utils/auth'
import axios from 'axios'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain
  },
  computed: {
    ...mapGetters([
      'name'
    ])
  },
  data() {
    return {
      tokenCheckInterval: null // 存储定时器ID
    }
  },
  created() {
    // 设置定时器，每15分钟检查一次token状态
    this.tokenCheckInterval = setInterval(this.checkTokenValidity, 15 * 60 * 1000)
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval)
    }
  },
  methods: {
    goToChangePassword() {
      this.$router.push('/change-password')
    },
    logout() {
      // 登出前先显示提示消息
      this.$message({
        message: '退出登录中...',
        type: 'info',
        duration: 1000
      })

      // 直接调用store的logout action
      this.$store.dispatch('user/logout')
        .then(() => {
          // 在store中已处理重定向逻辑，此处不需要额外处理
        })
        .catch(error => {
          console.error('退出登录失败:', error)
          // 即使失败也尝试跳转回登录页
          this.$router.push('/login')
        })
    },
    // 检查token是否有效
    checkTokenValidity() {
      const token = getToken()
      if (!token) {
        // 如果没有token，直接跳转到登录页
        this.handleTokenInvalid()
        return
      }

      // 发送请求验证token有效性
      // 这里使用一个简单的GET请求，可以是任何API端点，只需要带上token并检查响应
      axios.get('/api/check-auth', {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }).catch(error => {
        // 如果返回401或其他未授权错误，说明token无效
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          console.warn('Token已过期或无效，自动登出')
          this.handleTokenInvalid()
        }
      })
    },
    // 处理token无效的情况
    handleTokenInvalid() {
      // 显示提示消息
      this.$message({
        message: '登录状态已过期，请重新登录',
        type: 'warning',
        duration: 3000
      })
      
      // 清除token并重定向到登录页
      this.$store.dispatch('user/resetToken').then(() => {
        window.location.href = '/login'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
  
  .el-header {
    padding: 0;
    background-color: #304156;
    color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 10;
    
    .header {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      
      .logo-title {
        display: flex;
        align-items: center;
        
        .header-logo {
          height: 40px;
          margin-right: 10px;
        }
        
        h2 {
          margin: 0;
          font-size: 18px;
        }
      }
      
      .user-info {
        display: flex;
        align-items: center;
        
        .welcome-text {
          margin-right: 15px;
        }
        
        .el-dropdown-link {
          cursor: pointer;
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
  
  .el-aside {
    background-color: #304156;
    overflow: hidden;
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 9;
  }
  
  .el-main {
    padding: 20px;
    background-color: #f0f2f5;
  }
}
</style>
